<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="filteredTenants"
      class="elevation-1"
      :loading="loadingTable"
      item-key="key"
      fixed-header
      disable-filtering
      :items-per-page="perPage"
      :page="page"
      hide-default-footer
      @update:sort-desc="() => page = 1"
      @update:sort-by="() => page = 1"
    >
      <template v-slot:top>
        <v-toolbar
          class="toolbar"
          height="84"
          flat
        >
          <div class="d-flex align-center w-100">
            <v-select
              v-model="tenant"
              :items="tableData"
              item-text="tenantFriendlyName"
              item-value="tenantFriendlyName"
              class="select-components ma-md-3 mt-3"
              single-line
              solo
              dense
              @change="onChangeTenant"
            />
            <v-spacer />
            <FilterInput
              v-model="filter"
              :items="headers"
            />
          </div>
        </v-toolbar>

        <v-divider />
      </template>

      <template v-slot:no-data>
        <v-btn
          color="primary"
          dark
          @click="getTableData"
        >
          Refresh
        </v-btn>
      </template>

      <template v-slot:footer>
        <v-container
          fluid
          class="mt-4"
        >
          <v-row>
            <v-col
              cols="9"
              align-self="center"
            >
              <v-pagination
                v-model="page"
                class="b-pagination"
                :length="paginationLength"
                :total-visible="11"
                @input="onChangePage"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="perPage"
                class="select-per-page"
                :items="perPageItems"
                placeholder="Items per page"
                dance
                @change="perPage = parseInt($event, 10)"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import FilterInput from "../FilterInput";

export default {
  name: "AnalyzerTable",
  components: {
    FilterInput,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    getTableDataAction: {
      type: String,
      required: true
    },
    tableDataGetter: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loadingTable: false,
      tenant: '',
      page: 1,
      perPage: 10,
      perPageItems: [10, 25, 50, 100, 500],
      filter: []
    }
  },
  computed: {
    tableData() {
      return this.$store.getters[this.tableDataGetter];
    },
    tenants () {
      return this.tableData.map(item => item.tenantFriendlyName);
    },
    recordsForSelectedTenant () {
      return this.tableData.find(item => item.tenantFriendlyName === this.tenant)?.records;
    },
    filteredTenants () {
      if (!this.filter?.length) {
        return this.recordsForSelectedTenant;
      }

      return this.recordsForSelectedTenant.filter(item => {
        let isFilter = true;
        this.filter.forEach((_item) => {
          isFilter = isFilter && item[_item.key]?.toLowerCase() === _item.value?.toLowerCase();
        });

        return isFilter;
      })
    },
    paginationLength() {
      return Math.ceil(this.filteredTenants?.length / this.perPage) || 1;
    },
    filterStringURL: {
      get() {
        return this.filter.map(item => {
          return `${item.key}:${item.value}:${item.name}`;
        }).join(",");
      },
      set(newValue) {
        const filterArray = newValue.split(",");
        filterArray.forEach((item, index) => {
          const filterKeyValue = item.split(":")

          const filterItem = {
            key: filterKeyValue[0],
            value: filterKeyValue[1],
            name: filterKeyValue[2],
          };

          this.$set(this.filter, index, filterItem);
        });

        return newValue;
      }
    }
  },
  watch: {
    tenant(newValue) {
      this.addHashToLocation('tenant', newValue);
    },
    perPage(newValue) {
      this.addHashToLocation("perPage", newValue);
    },
    filterStringURL(newValue) {
      this.page = 1;
      this.addHashToLocation("page", 1);
      this.addHashToLocation("filter", newValue);
    }
  },
  async created() {
    await this.getTableData();

    this.restorePageFromQuery();
  },
  methods: {
    restorePageFromQuery() {
      if (!this.$route.query) {
        return;
      }

      const query = this.$route.query;
      const tenant = decodeURIComponent(query?.tenant);
      if (tenant) {
        const _tenant = this.tenants.find(item => item === tenant);
        this.tenant = _tenant || this.tenants[0];
      } else {
        this.tenant = this.tenants[0];
      }

      if (query?.page) {
        this.page = Number(query.page);
      }

      if (query?.perPage) {
        this.perPage = Number(query.perPage);
      }

      if (query?.filter) {
        this.filterStringURL = decodeURIComponent(query.filter);
      }
    },
    async getTableData() {
      try {
        this.loadingTable = true;

        await this.$store
            .dispatch(this.getTableDataAction);
      } finally {
        this.loadingTable = false;
      }
    },
    addHashToLocation(key, value) {
      const url = new URL(window.location);
      url.searchParams.set(key, encodeURIComponent(value));
      window.history.pushState({}, '', url);
    },
    onChangePage() {
      this.addHashToLocation("page", this.page);
    },
    onChangeTenant() {
      this.filter = [];
    }
  }
}
</script>

<style scoped>
.select-components {
  min-width: 250px;
  max-width: 250px;
  height: 38px;
}
</style>